/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Lead from './Lead/index'
import No from './No/index'
import Person from './Person/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PersonMatches/Content/PersonMatch/Details/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let personMatchTypeValueData = fromData.useDataValue({ viewPath,
context: 'person_match',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: personMatchTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Lead'}>
<Lead
  viewPath={`${viewPath}/Lead`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Person'}>
<Person
  viewPath={`${viewPath}/Person`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}